/* Alpha Everstrong — HEADER davranislari
   1) Kaydirinca bar kisalir, guven seridi gizlenir, buton yerini mini urun karti alir
   2) Mobil cekmece  3) Arama paneli
   4) Mobil alt satin alma cubugu — sayfadaki asil sepete ekle butonu
      ekranda goruntulenirken gizlenir, kaybolunca geri gelir            */
(function () {
  var hdr = document.querySelector('[data-alpha-header]');
  if (!hdr) return;

  /* ---- 1. yapiskan durum ---- */
  var THRESHOLD = 240;
  var sticky = false;
  function onScroll() {
    var want = window.scrollY > THRESHOLD;
    if (want !== sticky) { sticky = want; hdr.classList.toggle('is-sticky', want); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---- 2. cekmece ---- */
  var drawer = hdr.querySelector('[data-alpha-drawer]');
  var openBtns = hdr.querySelectorAll('[data-alpha-drawer-open]');
  var closeBtns = hdr.querySelectorAll('[data-alpha-drawer-close]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    Array.prototype.forEach.call(openBtns, function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) { var first = drawer.querySelector('a, button'); if (first) first.focus(); }
  }
  Array.prototype.forEach.call(openBtns, function (b) { b.addEventListener('click', function () { setDrawer(true); }); });
  Array.prototype.forEach.call(closeBtns, function (b) { b.addEventListener('click', function () { setDrawer(false); }); });

  /* ---- 3. arama ---- */
  var search = hdr.querySelector('[data-alpha-search]');
  var searchBtns = hdr.querySelectorAll('[data-alpha-search-toggle]');
  function setSearch(open) {
    if (!search) return;
    search.hidden = !open;
    Array.prototype.forEach.call(searchBtns, function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) { var i = search.querySelector('input'); if (i) i.focus(); }
  }
  Array.prototype.forEach.call(searchBtns, function (b) {
    b.addEventListener('click', function () { setSearch(search && search.hidden); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { setDrawer(false); setSearch(false); }
  });

  /* ---- 4. mobil alt satin alma cubugu ---- */
  var bar = document.querySelector('[data-alpha-buybar]');
  if (!bar) return;

  var mainAtc = document.querySelector('[data-alpha-submit]');
  var atcVisible = false;
  if (mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      atcVisible = entries[0].isIntersecting; update();
    }, { rootMargin: '-10px 0px -80px 0px' }).observe(mainAtc);
  }
  function update() {
    var past = window.scrollY > 420;
    bar.classList.toggle('show', past && !atcVisible);
  }
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();

  /* Varyant degisince cubuktaki fiyat, isim ve sepete eklenen varyant da degissin. */
  var picker = document.querySelector('[data-alpha-pdp] .a-vars');
  if (!picker) return;

  var data = null;
  var tag = document.querySelector('[data-alpha-variants]');
  if (tag) { try { data = JSON.parse(tag.textContent); } catch (e) { data = null; } }
  if (!data) return;

  function money(cents) {
    if (!data.moneyFormat) return '';
    var s = (cents / 100).toFixed(2).replace('.', ',');
    s = s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return data.moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, s);
  }

  picker.addEventListener('click', function (e) {
    var label = e.target.closest ? e.target.closest('[data-alpha-variant]') : null;
    if (!label) return;
    var id = parseInt(label.getAttribute('data-alpha-variant'), 10);
    var v = data.variants.filter(function (x) { return x.id === id; })[0];
    if (!v) return;

    var price = bar.querySelector('[data-buybar-price]');
    var name = bar.querySelector('[data-buybar-name]');
    var input = bar.querySelector('[data-buybar-id]');
    var btn = bar.querySelector('button[name="add"]');
    var vname = label.querySelector('.a-vname');

    if (price) price.textContent = money(v.price);
    if (name && vname) name.textContent = vname.textContent.trim();
    if (input) input.value = v.id;
    if (btn) {
      btn.disabled = !v.available;
      btn.textContent = v.available ? (data.addLabel || 'Sepete Ekle') : (data.soldLabel || 'Tükendi');
    }
  });
})();
